import * as actionTypes from "../../../Redux/Actions/actionTypes";

const initialState = {
  success: "",
  error: "",
};

const RegisterReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REGISTER_RESPONSE:
      return {
        ...state,
        success: action.success,
        error: "",
      };
    case actionTypes.REGISTER_ERROR:
      return {
        ...state,
        error: action.error,
        success: "",
      };
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
};

export default RegisterReducer;
